enum DateTimeFormatDescription {
	Undefined = 0,
	Short = 1,
	Medium = 2,
	Long = 3,
	Full = 4
}

export default DateTimeFormatDescription;
